<div class="profile-container">
    <div class="profile-content">
        <div class="personal-details">
            <div class="header-block">
                <div class="header-title">
                    <p style="margin: 0; font-size: 1.25rem; font-weight: 600;">Publishing Workflow</p>
                </div>
                <div class="add-block">
                    <div class="filter-icon">
                        <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                </div>
            </div>

            <div class="desktop-view">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 20%;">Episode Name</th>
                            <th style="width: 20%;">Episode Type</th>
                            <th style="width: 20%;">Shoot Date</th>
                            <th style="width: 20%;">Status</th>
                            <th style="width: 20%;text-align: center;padding: 0;">Action</th>
                        </tr>
                    </thead>
                </table>

                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let episode of episodeList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        }">

                        <p style="width: 20%;" [title]="episode.episodeName">{{episode.episodeName || " -- " }}</p>
                        <p style="width: 20%;">{{episode.episodeType || " -- " }}</p>
                        <p style="width: 20%;">{{ (episode.shootDate && episode.shootDate !== 0 ? (episode.shootDate |
                            date:'mediumDate') : null) || " -- " }}</p>
                        <p style="width: 20%;">{{statusMap[episode.episodeStatus] || episode.episodeStatus || " -- " }}</p>

                        <p class="action-buttons" style="width: 20%;padding-left: 25px; text-align: center;">
                            <i data-toggle="modal" title="View" (click)="openViewModal(episode)" data-target="#viewModal"
                                class="bi bi-eye-fill" style="cursor: pointer; margin-right: 12px;"></i>

                        </p>
                    </div>
                </div>
            </div>

            <!-- Mobile Card View -->
            <div class="mobile-view" *ngIf="!isLoading">
                <div class="episode-card"
                    *ngFor="let episode of episodeList | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }">
                    <div class="card-header">
                        <h3>{{episode.episodeName || "Unnamed Episode" }}</h3>
                        <div class="actions">
                            <i data-toggle="modal" title="View" (click)="openViewModal(episode)" data-target="#viewModal"
                                class="bi bi-eye-fill"></i>
                        </div>
                    </div>
                    
                    <div class="status" [ngClass]="{'pending': episode.episodeStatus?.includes('PENDING'), 'inprogress': episode.episodeStatus === 'EPISODE_CREATION' || episode.episodeStatus === 'QC_REJECTED'}">
                        <i class="bi bi-check-circle-fill" *ngIf="episode.episodeStatus?.includes('COMPLETED')"></i>
                        {{statusMap[episode.episodeStatus] || episode.episodeStatus || "PENDING" }}
                    </div>

                    <div class="details">
                        <div class="detail-row">
                            <span>Id</span>
                            <strong>{{episode.tvProductionTrackerId || "--"}}</strong>
                        </div>
                        <div class="detail-row">
                            <span>Anchor</span>
                            <strong>{{episode.anchorUser || "--"}}</strong>
                        </div>
                        <div class="detail-row">
                            <span>Director</span>
                            <strong>{{episode.director || "--"}}</strong>
                        </div>
                        <div class="detail-row">
                            <span>Shoot Date</span>
                            <strong>{{ (episode.shootDate && episode.shootDate !== 0 ? (episode.shootDate | date:'mediumDate') : null) || "--" }}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && episodeList.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
            </div>
        </div>
    </div>
</div>



<!-- View Modal -->
<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="viewModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 1400px;">
        <div class="modal-content ent-modal-content">

            <div class="modal-header ent-modal-header">
                <div class="ent-header-left">
                    <h5 class="modal-title ent-title" id="viewModalLabel">Episode Details</h5>
                    <p class="ent-subtitle">TV Production Workflow</p>
                </div>
                <div class="ent-header-right">
                    <span class="ent-badge" [ngClass]="{
                        'ent-badge-success': singleEpisodeData[0]?.episodeStatus?.includes('COMPLETED'),
                        'ent-badge-warning': singleEpisodeData[0]?.episodeStatus?.includes('PENDING') || singleEpisodeData[0]?.episodeStatus === 'EPISODE_CREATION',
                        'ent-badge-primary': !singleEpisodeData[0]?.episodeStatus?.includes('COMPLETED') && !singleEpisodeData[0]?.episodeStatus?.includes('PENDING')
                    }">
                        {{statusMap[singleEpisodeData[0]?.episodeStatus] || singleEpisodeData[0]?.episodeStatus ||
                        'PENDING'}}
                    </span>
                    <button type="button" class="close ent-close-btn" data-dismiss="modal" aria-label="Close"
                        (click)="closePopUp()" id="closeViewModalButton">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>

            <div class="modal-body ent-modal-body" *ngIf="singleEpisodeData[0]">

                <!-- Workflow Stepper -->
                <div class="ent-stepper-container">
                    <ng-container *ngFor="let step of workflowSteps; let last = last">
                        <div class="ent-step"
                            [ngClass]="{'completed': isStageCompleted(singleEpisodeData[0]?.currentStage, step.stage), 'active': isStageActive(singleEpisodeData[0]?.currentStage, step.stage)}">
                            <div class="ent-step-circle"></div>
                            <div class="ent-step-label">{{step.label}}</div>
                        </div>
                        <div *ngIf="!last" class="ent-step-connector"
                            [ngClass]="{'completed': isStageCompleted(singleEpisodeData[0]?.currentStage, step.stage)}">
                        </div>
                    </ng-container>
                </div>

                <div class="ent-grid">

                    <!-- Episode Information Card -->
                    <div class="ent-card">
                        <h5 class="ent-card-title">Episode Information</h5>
                        <div class="ent-card-grid-3">
                            <div class="ent-field"><span class="ent-label">Id</span><span
                                    class="ent-value">{{singleEpisodeData[0].tvProductionTrackerId || '--'}}</span>
                            </div>
                            <div class="ent-field"><span class="ent-label">Episode Name</span><span
                                    class="ent-value">{{singleEpisodeData[0].episodeName || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Episode Type</span><span
                                    class="ent-value">{{singleEpisodeData[0].episodeType || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Anchor</span><span
                                    class="ent-value">{{singleEpisodeData[0].anchorUser || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Director</span><span
                                    class="ent-value">{{singleEpisodeData[0].director || '--'}}</span></div>
                            <div class="ent-field">
                                <span class="ent-label">Guest</span>
                                <span class="ent-value">
                                    <ng-container
                                        *ngIf="singleEpisodeData[0].guest1">{{singleEpisodeData[0].guest1}}</ng-container>
                                    <ng-container *ngIf="singleEpisodeData[0].guest1 && singleEpisodeData[0].guest2">,
                                    </ng-container>
                                    <ng-container
                                        *ngIf="singleEpisodeData[0].guest2">{{singleEpisodeData[0].guest2}}</ng-container>
                                    <ng-container
                                        *ngIf="!singleEpisodeData[0].guest1 && !singleEpisodeData[0].guest2">--</ng-container>
                                </span>
                            </div>
                            <div class="ent-field"><span class="ent-label">Status Badge</span><span
                                    class="ent-value">{{statusMap[singleEpisodeData[0]?.episodeStatus] ||
                                    singleEpisodeData[0].episodeStatus || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Shoot Date</span><span class="ent-value">{{
                                    (singleEpisodeData[0].shootDate && singleEpisodeData[0].shootDate !== 0 ?
                                    (singleEpisodeData[0].shootDate | date:'mediumDate') : null) || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Shoot Time</span><span
                                    class="ent-value">{{singleEpisodeData[0].shootTime || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Episode Due Date</span><span
                                    class="ent-value">{{ (singleEpisodeData[0].episodeDueDate && singleEpisodeData[0].episodeDueDate !== 0 ? (singleEpisodeData[0].episodeDueDate | date:'mediumDate') : null) || '--'}}</span></div>
                        </div>

                    </div>

                    <div class="ent-grid">
                        <!-- Editor Information -->
                        <div class="ent-card" *ngIf="singleEpisodeData[0].editorUser">
                            <h5 class="ent-card-title">Editor Information</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">Editor</span><span
                                        class="ent-value">{{singleEpisodeData[0].editorUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToEditorOnDate &&
                                        singleEpisodeData[0].assignToEditorOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToEditorOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].editStartDate &&
                                        singleEpisodeData[0].editStartDate !== 0 ? (singleEpisodeData[0].editStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].editDueDate &&
                                        singleEpisodeData[0].editDueDate !== 0 ? (singleEpisodeData[0].editDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Completed Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].editEndDate &&
                                        singleEpisodeData[0].editEndDate !== 0 ? (singleEpisodeData[0].editEndDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                            </div>
                        </div>



                        <!-- Graphics Team -->
                        <div class="ent-card" *ngIf="singleEpisodeData[0].graphicsUser">
                            <h5 class="ent-card-title">Graphics Team</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">Graphics User</span><span
                                        class="ent-value">{{singleEpisodeData[0].graphicsUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToGraphicsTeamOnDate &&
                                        singleEpisodeData[0].assignToGraphicsTeamOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToGraphicsTeamOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].graphicsCreationStartDate &&
                                        singleEpisodeData[0].graphicsCreationStartDate !== 0 ?
                                        (singleEpisodeData[0].graphicsCreationStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].graphicsDueDate &&
                                        singleEpisodeData[0].graphicsDueDate !== 0 ? (singleEpisodeData[0].graphicsDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Completed Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].graphicsCreationEndDate &&
                                        singleEpisodeData[0].graphicsCreationEndDate !== 0 ?
                                        (singleEpisodeData[0].graphicsCreationEndDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                            </div>
                        </div>

                        <!-- Title Team -->
                        <div class="ent-card" *ngIf="singleEpisodeData[0].titleCreationUser">
                            <h5 class="ent-card-title">Title Team</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">Assigned User</span><span
                                        class="ent-value">{{singleEpisodeData[0].titleCreationUser || '--'}}</span>
                                </div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToTitleTeamOnDate &&
                                        singleEpisodeData[0].assignToTitleTeamOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToTitleTeamOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].titleCreationStartDate &&
                                        singleEpisodeData[0].titleCreationStartDate !== 0 ?
                                        (singleEpisodeData[0].titleCreationStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].titleDueDate &&
                                        singleEpisodeData[0].titleDueDate !== 0 ? (singleEpisodeData[0].titleDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Completed Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].titleCreationEndDate &&
                                        singleEpisodeData[0].titleCreationEndDate !== 0 ?
                                        (singleEpisodeData[0].titleCreationEndDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Approved Title</span><span
                                        class="ent-value">{{singleEpisodeData[0].approvedTitle
                                        || '--'}}</span></div>
                                <div class="ent-field" style="grid-column: span 2;"
                                    *ngIf="singleEpisodeData[0].suggestedTitles?.length">
                                    <span class="ent-label">Suggested Titles</span>
                                    <div class="ent-pills">
                                        <span class="ent-pill"
                                            *ngFor="let title of singleEpisodeData[0].suggestedTitles">{{title.titleName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Quality Check Team -->
                        <div class="ent-card" *ngIf="singleEpisodeData[0].qualityCheckUser">
                            <h5 class="ent-card-title">Quality Check Team</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">Quality Check User</span><span
                                        class="ent-value">{{singleEpisodeData[0].qualityCheckUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToQualityCheckTeamOnDate &&
                                        singleEpisodeData[0].assignToQualityCheckTeamOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToQualityCheckTeamOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].qualityCheckStartDate &&
                                        singleEpisodeData[0].qualityCheckStartDate !== 0 ?
                                        (singleEpisodeData[0].qualityCheckStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].qualityDueDate &&
                                        singleEpisodeData[0].qualityDueDate !== 0 ? (singleEpisodeData[0].qualityDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                            </div>
                        </div>

                        <!-- SEO Team -->
                        <div class="ent-card" *ngIf="singleEpisodeData[0].seoUser">
                            <h5 class="ent-card-title">SEO Team</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">SEO User</span><span
                                        class="ent-value">{{singleEpisodeData[0].seoUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToSEOTeamOnDate &&
                                        singleEpisodeData[0].assignToSEOTeamOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToSEOTeamOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].seoTeamStartDate &&
                                        singleEpisodeData[0].seoTeamStartDate !== 0 ?
                                        (singleEpisodeData[0].seoTeamStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].seoDueDate &&
                                        singleEpisodeData[0].seoDueDate !== 0 ? (singleEpisodeData[0].seoDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Completed Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].seoTeamEndDate &&
                                        singleEpisodeData[0].seoTeamEndDate !== 0 ? (singleEpisodeData[0].seoTeamEndDate
                                        |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Approved SEO Title</span><span
                                        class="ent-value">{{singleEpisodeData[0].approvedSeoTitle || '--'}}</span>
                                </div>
                                <div class="ent-field" style="grid-column: span 2;"
                                    *ngIf="singleEpisodeData[0].suggestedSEOTitles?.length">
                                    <span class="ent-label">Suggested SEO Titles</span>
                                    <div class="ent-pills">
                                        <span class="ent-pill"
                                            *ngFor="let title of singleEpisodeData[0].suggestedSEOTitles">{{title.seoTitleName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Publishing Team -->
                        <div class="ent-card"
                            *ngIf="singleEpisodeData[0].publishingUser || singleEpisodeData[0].episodeYouTubeURL">
                            <h5 class="ent-card-title">Publishing Team</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">Publishing User</span><span
                                        class="ent-value">{{singleEpisodeData[0].publishingUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToPublishingTeamOnDate &&
                                        singleEpisodeData[0].assignToPublishingTeamOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToPublishingTeamOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].publishingStartDate &&
                                        singleEpisodeData[0].publishingStartDate !== 0 ?
                                        (singleEpisodeData[0].publishingStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].publishingDueDate &&
                                        singleEpisodeData[0].publishingDueDate !== 0 ? (singleEpisodeData[0].publishingDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Completed Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].publishingEndDate &&
                                        singleEpisodeData[0].publishingEndDate !== 0 ?
                                        (singleEpisodeData[0].publishingEndDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field" style="grid-column: span 2;"
                                    *ngIf="singleEpisodeData[0].episodeYouTubeURL">
                                    <span class="ent-label">YouTube URL</span>
                                    <span class="ent-value"><a [href]="singleEpisodeData[0].episodeYouTubeURL"
                                            target="_blank">{{singleEpisodeData[0].episodeYouTubeURL}}</a></span>
                                </div>
                            </div>
                        </div>

                        <!-- Common Notes Section -->
                        <div class="ent-card" style="grid-column: 1 / -1;"
                            *ngIf="singleEpisodeData[0].commonNotes?.length">
                            <h5 class="ent-card-title">Chat</h5>
                            <div class="ent-notes-list" style="max-height: 350px; overflow-y: auto;">
                                <div class="ent-note-card" *ngFor="let note of singleEpisodeData[0].commonNotes"
                                    [ngClass]="isMyNote(note) ? 'chat-bubble-mine' : 'chat-bubble-other'">
                                    <p class="ent-note-body">{{note.episodeNotes || note.commonNotes || note.editorNotes
                                        || note.titleNotes || note.graphicsNotes || note.seoNotes ||
                                        note.qualityCheckNotes || note.publishingNotes}}</p>
                                    <div class="ent-note-footer">
                                        <div class="ent-note-user"><i class="bi bi-person-fill"></i> {{note.userName ||
                                            note.userId || 'User'}}</div>
                                        <div class="ent-note-time">
                                            <span *ngIf="note.date">{{note.date | date:'short'}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Footer -->
            </div>
            <div class="modal-footer ent-modal-footer" *ngIf="singleEpisodeData[0]">

                <div class="ent-footer-right">
                    <button class="ent-btn-secondary" data-dismiss="modal" (click)="closePopUp()">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>